import {useCallback, useRef, useState} from 'react';

const useBillingConfirm = () => {
  const [prompt, setPrompt] = useState(null);
  const pending = useRef(null);

  const confirmFirst = useCallback(
    (impact, settingKey) =>
      new Promise(resolve => {
        if (pending.current) {
          resolve(false);
          return;
        }
        pending.current = resolve;
        setPrompt({impact, settingKey});
      }),
    []
  );

  const answer = useCallback(confirmed => {
    const resolve = pending.current;
    pending.current = null;
    setPrompt(null);
    if (resolve) resolve(confirmed);
  }, []);

  return {prompt, confirmFirst, answer};
};

export default useBillingConfirm;
